if (!customElements.get('accordion-component')) {
	customElements.define('accordion-component', class ComponentAccordions extends HTMLElement {
		constructor() {
			super();
			this.toggleButton = this.querySelector('[data-accordion-title]')
			this.panel = this.querySelector('[data-accordion-content]')
			this.accordionIcon = this.querySelector('[data-accordion-icon]')

			this.toggleButton.addEventListener('click', this.toggleAccordion.bind(this))
		}

		get isOpen() {
			return this.hasAttribute('open')
		}

		set isOpen(val) {
			if (val) {
				this.setAttribute('open', '')
				this.panel.setAttribute('aria-expanded', 'true')
			} else {
				this.removeAttribute('open')
				this.panel.setAttribute('aria-expanded', 'false')
			}
		}

		set buttonOpen(value) {
			this.toggleButton.setAttribute('aria-expanded', value)
		}

		toggleAccordion() {
			this.isOpen ? this.close() : this.open()
		}

		open() {
			this.panel.style.cssText = `
			display: block;
			height: 0;
		`

			const maxHeight = this.panel.scrollHeight
			this.panel.style.height = maxHeight + 'px'

			this.buttonOpen = 'true'

			this.panel.addEventListener('transitionend', () => {
				this.isOpen = 'true'
			}, {once: true})
		}

		close() {
			this.panel.style.height = this.panel.scrollHeight + 'px'

			this.buttonOpen = 'false'

			requestAnimationFrame(() => {
				this.panel.style.transition = ''
				requestAnimationFrame(() => this.panel.style.height = '0px')
			})

			this.panel.addEventListener('transitionend', () => {
				this.isOpen = ''
				this.panel.style.display = 'none'
			}, {once: true})
		}
	})
}